module.exports = __webpack_public_path__ + "static/media/laptop.4794fd65.png";